import { Point } from 'slate';
export default function getPointFromTextsSnapshot(editor, textsSnapshot) {
  var knownText = textsSnapshot.findLast(function (text) {
    return editor.value.document.hasNode(text.key);
  }) || editor.value.document.getFirstText();
  return Point.create({
    key: knownText.key,
    offset: knownText.text.length
  }).normalize(editor.value.document);
}